export default __webpack_public_path__ + "1b42b4b7c6bd1692bdf34e15582af167.svg";